
<p>Modular {{ 'routes.home' | translate }}</p>
<router-outlet></router-outlet>